import { render, staticRenderFns } from "./ImovelCadastroDialog.vue?vue&type=template&id=45596368&scoped=true&"
import script from "./ImovelCadastroDialog.vue?vue&type=script&lang=js&"
export * from "./ImovelCadastroDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImovelCadastroDialog.vue?vue&type=style&index=0&id=45596368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45596368",
  null
  
)

export default component.exports